/* eslint-disable import/prefer-default-export */
export const UPDATE_MOBILE_CONFIG = 'UPDATE_MOBILE_CONFIG';
export const UPDATE_WEB_CONFIG = 'UPDATE_WEB_CONFIG';
export const TOGGLE_V3 = 'TOGGLE_V3';
